/**
 * Date-extensions locale Malayalam [ml]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('ml', {
    monthNames: ['ജനുവരി','ഫെബ്രുവരി','മാർച്ച്','ഏപ്രിൽ','മേയ്','ജൂൺ','ജൂലൈ','ഓഗസ്റ്റ്','സെപ്റ്റംബർ','ഒക്ടോബർ','നവംബർ','ഡിസംബർ'],
    monthShortNames: ['ജനു.','ഫെബ്രു.','മാർ.','ഏപ്രി.','മേയ്','ജൂൺ','ജൂലൈ.','ഓഗ.','സെപ്റ്റ.','ഒക്ടോ.','നവം.','ഡിസം.'],
    dayNames: ['ഞായറാഴ്ച','തിങ്കളാഴ്ച','ചൊവ്വാഴ്ച','ബുധനാഴ്ച','വ്യാഴാഴ്ച','വെള്ളിയാഴ്ച','ശനിയാഴ്ച'],
    dayShortNames: ['ഞായർ','തിങ്കൾ','ചൊവ്വ','ബുധൻ','വ്യാഴം','വെള്ളി','ശനി']
});
